import template from './travelInvoicePreviewModal.html';
import controller from './travelInvoicePreviewModal.controller';

let TravelInvoicePreviewModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'travel-invoice-preview-modal hmodal-info animated zoomIn'
};

export default TravelInvoicePreviewModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/TravelInvoicePreviewModal/travelInvoicePreviewModal.component.js